import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'RESEARCH_UPDATE',
    smsDelete : 'RESEARCH_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        category: [],
        research: [],
        research_details: {},

        submitSuccess: false,
        categoryLoading: false,
        categoryError: false,
        researchLoading: false,
        researchError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CATEGORY(state, results) {
            state.category = results;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, hasError) {
            state.categoryError = hasError;
        },

        SET_RESEARCH(state, results) {
            state.research = results;
        },

        GET_RESEARCH_DETAILS (state, items) {
            state.research_details = items
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        RESEARCH_LOADING (state, loading) {
            state.researchLoading = loading;
        },

        RESEARCH_ERROR (state, hasError) {
            state.researchError = hasError;
        }
    },

    actions: {
        // Category 
        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_research_category, payload.category, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchCategory ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.research_category_list, config);
                let response = result.data.data
                commit('SET_CATEGORY', response);
                return result
            } catch(error) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async deleteCategory({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_research_category + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCategory')
            return response
        },

        // Research
        async addResearch ({commit, dispatch}, payload) {
            commit('RESEARCH_LOADING', true);
            commit('RESEARCH_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_research, payload.research, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchResearch')
                return response

            } catch (e) {
                commit('RESEARCH_ERROR', true);
            } finally {
                commit('RESEARCH_LOADING', false);
            }
        },

        async fetchResearch ({ commit }) {
            commit('RESEARCH_LOADING', true);
            commit('RESEARCH_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.research_list, config);
                let response = result.data.data
                commit('SET_RESEARCH', response);
                return result
            } catch(error) {
                commit('RESEARCH_ERROR', true);
            } finally {
                commit('RESEARCH_LOADING', false);
            }
        },

        async getDetails ({ commit }, payload) { 
            let response = await axios.get(V1API.get_research_details + payload).then(result => {
                let items = result.data.data
                commit('GET_RESEARCH_DETAILS', items)
                return result
            })
            return response
        },

        async updateResearch ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_research + payload.id, payload.research, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchResearch')
                return response

            } catch (e) {
                commit('RESEARCH_ERROR', true);
            } finally {
                commit('RESEARCH_LOADING', false);
            }
        },

        async deleteResearch({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_research + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchResearch')
            return response
        },

        async toggleFeatured ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_research_featured + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchResearch')
                return response

            } catch (e) {

            } finally {

            }
        },

        async toggleFeatured ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_research_featured + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchResearch')
                return response

            } catch (e) {

            } finally {

            }
        },

        async updateSerial ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.update_research_serial + payload.id + '/' + payload.serial, config).then(result => {
                let items = result.data
                // dispatch('getProjectList')
                return result
            })
            return response
        }
    },

    getters: {}
}
